export default __webpack_public_path__ + "assets/front/scss/error.0d259eef7fedf1927ab527333a6bd317.css";